import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-speakersimplenone",
  "use": "icon-th-speakersimplenone-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-speakersimplenone\">\n<path d=\"M19.4387 3.10123C19.2706 3.01929 19.0828 2.98616 18.8968 3.0056C18.7107 3.02505 18.5338 3.09629 18.3862 3.21123L9.65625 9.99998H4C3.46957 9.99998 2.96086 10.2107 2.58579 10.5858C2.21071 10.9608 2 11.4695 2 12V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H9.65625L18.3862 28.7887C18.534 28.9036 18.711 28.9747 18.8971 28.9939C19.0832 29.0132 19.271 28.9798 19.4391 28.8977C19.6072 28.8155 19.7489 28.6878 19.8481 28.5291C19.9472 28.3704 19.9999 28.1871 20 28V3.99998C20 3.81264 19.9474 3.62906 19.8482 3.47016C19.749 3.31126 19.6071 3.18343 19.4387 3.10123ZM18 25.955L10.6138 20.2112C10.4386 20.074 10.2225 19.9996 10 20H4V12H10C10.2225 12.0003 10.4386 11.9259 10.6138 11.7887L18 6.04498V25.955Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-speakersimplenone.svg
// module id = sPC4
// module chunks = 84